export class AuditLogSecurityContext {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloud",
            "baseName": "cloud",
            "type": "AuditLogCloudContext",
            "format": ""
        },
        {
            "name": "cloudDestination",
            "baseName": "cloudDestination",
            "type": "AuditLogCloudContext",
            "format": ""
        },
        {
            "name": "stateSnapshot",
            "baseName": "stateSnapshot",
            "type": "AuditLogStateSnapshot",
            "format": ""
        },
        {
            "name": "changeSource",
            "baseName": "changeSource",
            "type": "AuditLogChangeSource",
            "format": ""
        },
        {
            "name": "enrichmentStatus",
            "baseName": "enrichmentStatus",
            "type": "AuditLogEnrichmentStatus",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuditLogSecurityContext.attributeTypeMap;
    }
    constructor() {
    }
}
